import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_DEVICE, type Device } from './types';

const initialState: Device = {};

export function deviceReducer(state = initialState, action: PayloadAction<Device>): Device {
	switch (action.type) {
		case SET_DEVICE:
			return action.payload;
		default:
			return state;
	}
}
